import { AssembleTag } from "src/components/AssembleTags/AssembleTag";

export function OldTag(): JSX.Element {
  return <AssembleTag label="Old" />;
}
